// extracted by mini-css-extract-plugin
module.exports = {"items":"SetEmailAndPasswordForm_items__f3REz","button":"SetEmailAndPasswordForm_button__QDXMc"};